import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  TableCell,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import {
  MoreVert as MoreVertIcon,
  KeyboardArrowUp,
  KeyboardArrowDown,
  VerticalAlignTop as KeyboardDoubleArrowUp
} from '@mui/icons-material'

interface PriorityCellProps {
  rowId: string | number
  priorityNumber: number
  onMove: (id: string | number, direction: 'top' | 'up' | 'down') => void
}

export const PriorityCell: React.FC<PriorityCellProps> = ({
  rowId,
  priorityNumber,
  onMove
}) => {
  const styles = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const isMenuOpen = Boolean(anchorEl)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleMove = (direction: 'top' | 'up' | 'down') => {
    onMove(rowId, direction)
    handleMenuClose()
  }

  return (
    <TableCell align="center">
      <div className={styles.priorityContainer}>
        {priorityNumber > 0 && (
          <Typography variant="body2" className={styles.priorityNumber}>
            {priorityNumber}
          </Typography>
        )}
        <IconButton
          size="small"
          onClick={handleMenuOpen}
          aria-label="opciones de prioridad"
          className={styles.menuButton}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </div>
      
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          style: {
            maxHeight: 200
          }
        }}
      >
        <MenuItem onClick={() => handleMove('top')}>
          <KeyboardDoubleArrowUp fontSize="small" className={styles.menuIcon} />
          Mover al principio
        </MenuItem>
        <MenuItem onClick={() => handleMove('up')}>
          <KeyboardArrowUp fontSize="small" className={styles.menuIcon} />
          Mover arriba
        </MenuItem>
        <MenuItem onClick={() => handleMove('down')}>
          <KeyboardArrowDown fontSize="small" className={styles.menuIcon} />
          Mover abajo
        </MenuItem>
      </Menu>
    </TableCell>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  priorityContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5)
  },
  priorityNumber: {
    minWidth: '20px',
    fontWeight: 'bold',
    color: theme.palette.primary.main
  },
  menuButton: {
    padding: theme.spacing(0.25)
  },
  menuIcon: {
    marginRight: theme.spacing(1)
  }
}))